import { getErrorPayload } from '@application/common/helpers/api-helper';
import { createAsyncThunk } from '@reduxjs/toolkit';
import CalculationApi from '@infrastructure/calculation-api';
import { addSuccessNotification } from '../common/notificationSlice';
export const getAllCalculationsByWorkOrderIDAsync = createAsyncThunk('calculation/getAllCalculationsByWorkOrderID', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CalculationApi.getAllCalculationsByWorkOrderID(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createCalculationAsync = createAsyncThunk('calculation/create', async (calculation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CalculationApi.createCalculation(calculation);
        dispatch(addSuccessNotification("Record succesvol aangemaakt"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCalculationAsync = createAsyncThunk('calculation/update', async (calculation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CalculationApi.updateCalculation(calculation.id, calculation);
        dispatch(addSuccessNotification("Record succesvol bijgewerkt"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCalculationByIDAsync = createAsyncThunk('calculation/getCalculationByID', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CalculationApi.getCalculationByID(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCalculationByIdAsync = createAsyncThunk('calculation/delete', async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CalculationApi.deleteCalculationById(id);
        dispatch(addSuccessNotification("Record succesvol verwijderd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCalculationPositionAsync = createAsyncThunk('calculation/UpdateCalculationPosition', async (position, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CalculationApi.updateCalculationPosition(position);
        dispatch(addSuccessNotification('Calculatie Bedrag succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateBulkCalcualtionAsync = createAsyncThunk('calculation/UpdateBulkCalculation', async (calculation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CalculationApi.updateBulkCalculation(calculation);
        dispatch(addSuccessNotification('Record succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
